module["exports"] = [
  "Boeken",
  "Films",
  "Muziek",
  "Spelletjes",
  "Elektronica",
  "Computers",
  "Huis",
  "Tuin",
  "Gereedschap",
  "Kruiden",
  "Gezondheid",
  "Beauty",
  "Speelgoed",
  "Kinderen",
  "Baby",
  "Kleding",
  "Schoenen",
  "Sieraden",
  "Sport",
  "Verzorging",
  "Auto",
  "Industrieel"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/commerce/department.js
// module id = 3282
// module chunks = 1609